export type ProtoImageType = 'avatar' | 'avatar_large' | 'thumbnail' | 'detail' | 'original' | 'default';

export class ProtoImageConfig {
  // image size = double of css width!
  public static size: { [key in ProtoImageType]?: { width: number; height: number } } = {
    avatar: {
      height: 100,
      width: 100,
    },
    // eslint-disable-next-line camelcase
    avatar_large: {
      height: 240,
      width: 240,
    },
    detail: {
      height: 562,
      width: 750,
    },
    thumbnail: {
      height: 120,
      width: 120,
    },
  };

  public static placeholder: { [key in ProtoImageType]?: string } = {
    avatar: './assets/images/fallback/placeholder-thumbnail.png',
    // eslint-disable-next-line camelcase
    avatar_large: './assets/images/fallback/placeholder-thumbnail.png',
    default: './assets/images/fallback/placeholder-large.png',
    thumbnail: './assets/images/fallback/placeholder-thumbnail.png',
  };

  public static error: { [key in ProtoImageType]?: string } = {
    avatar: './assets/images/fallback/error-thumbnail.png',
    // eslint-disable-next-line camelcase
    avatar_large: './assets/images/fallback/error-thumbnail.png',
    default: './assets/images/fallback/error-large.png',
    thumbnail: './assets/images/fallback/error-thumbnail.png',
  };
}
